enum ExchangeRate {
  Default = 'default',
  Current = 'today',
  Historic = 'historical',
}

export default ExchangeRate;
